/**
 * plane-mark.tsx — the game's mark: the airline's plane, drawn solid, turned
 * to fly right. It is the brand of every night board (BoardBrand) and the top
 * of every way into the game; on the session's end a round mark holds it
 * (PLANE_MARK, in ToneMark). It lives here, under the game and the ways in
 * alike, because the ways in come before a match and may not import the
 * game's components.
 */

import { Icon } from '../ui/icon';
import { PLANE_MARK } from './plane-glyph';

/** The plane mark: the airline's plane, drawn solid, turned to fly right, at the brand's 16px. */
export function PlaneMark() {
  return <Icon glyph={PLANE_MARK} size="sm" />;
}
